import React from "react";
import { useTranslation } from "react-i18next";
import type { TransformedProduct } from "../../types/productApiTypes";

// --- Component Props ---
interface ProductCardActionsProps {
  product: TransformedProduct;
}

// --- Component Implementation ---
const ProductCardActions: React.FC<ProductCardActionsProps> = ({ product }) => {
  const { t } = useTranslation();

  return (
    <div className="product-card-actions">
      {/* "View Product" is now the primary and only action */}
      <a href={product.permalink} className="view-product-btn">
        {t("common.viewProduct", "View Product")}
      </a>
    </div>
  );
};

export default ProductCardActions;
